import { defaultViewLoader, ViewLoaderEnum } from 'src/app/view/models/view-loader.enum';
import { ViewQuizModeEnum } from 'src/app/view/models/view-quiz-mode.enum';

export class WidgetOptions {
  background = {
    colors: null,
  };

  // Misc
  uiAnnotations = false;
  uiAudio = false;
  uiInfo = true;
  uiFullscreen = true;

  // Timeline
  uiScrubber = false;

  uiHelp = true;

  // BG logo
  uiBd: '' | 'no-link' | 'false' = '';

  loadRotate: number = null;

  initial = {
    button: false,
    handHint: false,
    play: false,
  };

  disableScroll = {
    alert: false,
    overlay: false,
  };

  uiQuiz = {
    mode: ViewQuizModeEnum.Enabled,
    number: undefined,
  };

  autoLoad = true;

  // viewer params
  uiTour = false;
  uiNav = true;
  uiSearch = true;
  uiTools = true;
  uiUndo = true;
  uiLabelList = true;
  uiChapterList = false;
  all = false;
  collapseLabel: number = null;
  uiMenu = true;
  uiAnatomyDescriptions = false;
  uiTutorial = false;
  uiLegend = true;
  uiLoader: ViewLoaderEnum = defaultViewLoader;
  uiWhiteboard = true;
  uiVisibilityLayers = true;
  uiAnatomyLabels = true;
}
